module.exports = __webpack_public_path__ + "static/20943492-6d15431bc49ecc72410c380e7476682d.jpg";